// extracted by mini-css-extract-plugin
export default {"root":"DueDiligenceConfigCard_root__z7Iyd","optionalChip":"DueDiligenceConfigCard_optionalChip__wCpJU","hidden":"DueDiligenceConfigCard_hidden__8yA64"};